export const reduceUpdateTeamMemberRequest = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingTeamMember: true },
  };
};

export const reduceUpdateTeamMemberSuccess = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingTeamMember: false },
  };
};

export const reduceUpdateTeamMemberFailure = (state) => {
  return {
    ...state,
    ui: { ...state.ui, isUpdatingTeamMember: false },
  };
};
